import { createStore } from "vuex";

export const store = createStore({});
